import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { DataService } from '../services/data/data.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
    
  constructor(private dataService:DataService, private auth: AuthenticationService, private router:Router) {}
 
  async canActivate(route:ActivatedRouteSnapshot, state:RouterStateSnapshot) {
    const currentUser = await this.auth.getUser();
    // console.log('admin guard current user',currentUser);
    if(currentUser) {
      if(!currentUser.emailVerified){
        return this.router.createUrlTree(['action'],{ queryParams: { mode: 'sendEmailVerification'}});
      }
      else if(currentUser.role == 'admin'){
        return true;
      }
      else {
        return this.router.parseUrl(currentUser.role+'/'+currentUser.uid)
      }
    }
    else{
      // this.router.navigate(['login'], { queryParams: { returnUrl: state.url }});
      return this.router.createUrlTree(['login'],{ queryParams: { returnUrl: state.url }});
    }
  }
}